<section>
  <h2 class="fw-bold fs-normal">
    <a class="icon-link text-decoration-none" data-bs-toggle="collapse" href="#crimeGunIRsTable" role="button" aria-expanded="{{relatedInfoReports?.length > 0}}" aria-controls="crimeGunIRsTable">
      <i title="Show or hide information reports table" aria-hidden="true" [class]="toggleIconClass"></i>
      <span class="text-body">Information Reports</span>
    </a>
  </h2>
  <button *removeIfUnauthorizedIR="canCreateIR" class="btn btn-sm btn-active mb-3" type="button" (click)="addInfoReport.emit()">Add Information Report</button>
  <div #crimeGunIRsPanel id="crimeGunIRsTable" class="collapse {{relatedInfoReports?.length > 0 ? 'show' : ''}}" (hide.bs.collapse)="toggleClass('hide')" (show.bs.collapse)="toggleClass('show')">
    <p-table [value]="relatedInfoReports" [loading]="loading" [showLoader]="true" [columns]="cols" [rows]="rows" [paginator]="!isPrintView" [autoLayout]="true" [alwaysShowPaginator]="false" responsiveLayout="scroll" >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="col.sortable ? false : true">
            {{col.header}} <ng-container *ngIf="col.sortable"><p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon></ng-container>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-infoReport let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <th scope="row" *ngIf="columns[1].field == col.field;else default">
              <ng-container *removeIfUnauthorizedIR="canViewIR(infoReport); else staticText">
                <button *ngIf="!isPrintView; else staticText" type="button" class="btn btn-link" aria-label="{{'Information report tracking number '+infoReport[col.field]+' details'}}" tabindex="0" (click)="showInfoReportDetails.emit(infoReport)">{{ infoReport[col.field] }}</button>
              </ng-container>
              <ng-template #staticText>{{ infoReport[col.field] }}</ng-template>
            </th>
            <ng-template #default>
              <td [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'CreatedOn'">{{ infoReport[col.field] | utcToLocal:'MM/dd/yyyy  HH:mm' }}</ng-container>
                <ng-container *ngSwitchCase="'ModifiedOn'">{{ infoReport[col.field] | utcToLocal:'MM/dd/yyyy  HH:mm' }}</ng-container>
                <ng-container *ngSwitchCase="'IsPrimaryCrimeGun'">{{ infoReport[col.field] | booleanTransform}}</ng-container>
                <ng-container *ngSwitchCase="'Notes'"><span class="text-center">{{infoReport[col.field] | shortenText: 50}}</span><a *ngIf="!!infoReport.Notes && infoReport.Notes.length > 50" aria-label="show full notes" (click)="onShowFullNotesClicked(infoReport)"> [show full notes]</a></ng-container>
                <ng-container *ngSwitchDefault>{{infoReport[col.field]}}</ng-container>
              </td>
            </ng-template>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No information reports found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
